import { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'

import { FormTabType } from '@pages/WindowsCreateOrEdit/types'

import { useFetchAllFormQuery, useFetchAllObjectQuery, useFetchAllViewQuery } from '@redux/api'

import { WINDOW_ENTITY } from '@constants'

export const useTab = (sectionIndex: number, tabIndex: number) => {
  const {
    watch,
    formState: { errors },
    setValue,
  } = useFormContext<FormTabType>()
  const watchTabTitle = watch(`sections.${sectionIndex}.tabs.${tabIndex}.title`)
  const watchTabEntityType = watch(`sections.${sectionIndex}.tabs.${tabIndex}.entityType`)
  const watchTabObject = watch(`sections.${sectionIndex}.tabs.${tabIndex}.object`)

  const { data: objects, isLoading: loadingAllObjects } = useFetchAllObjectQuery()
  const objectsValues = useMemo(
    () =>
      objects?.map(obj => ({
        id: obj.code,
        label: obj.title,
      })),
    [objects]
  )

  const { data: views, isLoading: isLoadingViews } = useFetchAllViewQuery(
    {
      objectCode: watchTabObject?.id,
    },
    {
      skip: watchTabEntityType?.label !== WINDOW_ENTITY.VIEW || !watchTabObject?.id,
      refetchOnMountOrArgChange: true,
    }
  )

  const { data: forms, isLoading: isLoadingForms } = useFetchAllFormQuery(
    {
      objectCode: watchTabObject?.id,
    },
    {
      skip: watchTabEntityType?.label !== WINDOW_ENTITY.FORM || !watchTabObject?.id,
      refetchOnMountOrArgChange: true,
    }
  )

  const entityOptions = useMemo(() => {
    if (watchTabEntityType) {
      const source = WINDOW_ENTITY.VIEW === watchTabEntityType.label ? views?.data : forms?.data

      return (
        source?.map(entity => ({
          id: entity.id,
          label: entity.title,
          code: entity.code,
        })) ?? []
      )
    }
  }, [forms, views, watchTabEntityType, watchTabObject])

  const entityTypeOptions = [
    { id: 1, label: WINDOW_ENTITY.VIEW },
    { id: 2, label: WINDOW_ENTITY.FORM },
    // {id: 3, label: WINDOW_ENTITY.GANTT_CHART},
  ]

  return {
    state: {
      errors,
      setValue,
    },
    handlers: {},
    data: {
      watchTabTitle,
      objectsValues,
      loadingAllObjects,
      entityTypeOptions,
      entityOptions,
      isLoadingViews,
      isLoadingForms,
    },
  }
}
